import { useHookstate } from "@hookstate/core";
import { rootComponentsStore } from "../hookstate/rootComponentsStore";

export function useTopBarHeight() {
  return useHookstate(rootComponentsStore.topBarHeight);
}
